import {EmployeeToIssueAssignment} from "../domain/entities/employee-to-issue-assignment.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class DeleteEmployeeToIssueAssignmentCommand extends AbstractCommand<EmployeeToIssueAssignment> {

    name = CommandName.DELETE_EMPLOYEE_TO_ISSUE_ASSIGNMENT;

    tags = ["entity", "delete", "employee-to-issue-assignment", "issue", "employee"];

}